import React, { useEffect, useState } from 'react';
import { View, Image } from '@react-pdf/renderer';
import QRCode from 'qrcode';
import { styleQR } from './styleStudentOtpPdf';
const url = "https://sms.cooledsys.com";
const urlLocal = "192.168.1.3:3000";

const ParentAssessmentQr = ({ schoolId, tchId, acdYrId, studentId, clsId, qrSize }) => {
    const [qrLink, setQRLink] = useState("");
    const [qrImageUrl, setQrImageUrl] = useState("");

    useEffect(() => {
        const assessmentPageUrl = url+ `/hpcParentAssessment?tchId=${tchId}&stdId=${studentId}&schId=${schoolId}&acdYrId=${acdYrId}&clsId=${clsId}`;
        setQRLink(assessmentPageUrl);
    }, [schoolId, tchId, acdYrId, studentId]);

    useEffect(() => {
        if (qrLink) {
            QRCode.toDataURL(qrLink)
                .then((dataUrl) => {
                    setQrImageUrl(dataUrl);
                })
                .catch((error) => {
                    console.error('Error generating QR code image:', error);
                });
        }
    }, [qrLink]);

    return (
        <View style={{width:qrSize, height:qrSize}}>
            {qrImageUrl && <Image style={styleQR.image1} src={qrImageUrl} />}
        </View>
    );
};

export default ParentAssessmentQr;
